import type { useQueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useRules = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["rules", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].rules.$get({ param: scope.param })
        : await client.merchant[":merchantId"].rules.$get({ param: scope.param });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: enabled && !!scope.merchantId,
  });
};

export const useRulesImpact = () => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["rules-impact", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].rules.impact.$get({ param: scope.param })
        : await client.merchant[":merchantId"].rules.impact.$get({ param: scope.param });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!scope.merchantId,
  });
};

export const invalidateRulesDashboard = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: ["rules"] });
  queryClient.invalidateQueries({ queryKey: ["rules-impact"] });
};
